var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F05123;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,10.9c-0.5-0.6-1.3-1-2.1-1h-1.8c-0.2-4.5-3.6-8-7.7-8c-4.2,0-7.6,3.6-7.7,8H4c-0.8,0-1.5,0.4-2.1,1 c-0.7,0.8-0.9,1.9-0.7,3l2.2,9.2c0.3,1.4,1.5,2.4,2.8,2.4h14.7c1.3,0,2.4-1,2.8-2.4l2.2-9.2C26.1,12.9,25.8,11.8,25.2,10.9z  M13.5,3.9c3,0,5.5,2.7,5.7,6.1H7.9C8,6.6,10.5,3.9,13.5,3.9z M23.8,13.5l-2.2,9.2c-0.1,0.5-0.4,0.8-0.7,0.8H6.2 c-0.3,0-0.6-0.4-0.7-0.8l-2.2-9.2C3.1,13,3,11.9,4,11.9h19.1C24.1,11.9,23.9,13,23.8,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,13.9c-0.6,0-1,0.4-1,1V21c0,0.5,0.5,1,1,1s1-0.4,1-1v-6.1C9.4,14.3,9,13.9,8.4,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,13.9c-0.6,0-1,0.4-1,1V21c0,0.5,0.5,1,1,1c0.6,0,1-0.4,1-1v-6.1C14.4,14.3,14,13.9,13.4,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.4,13.9c-0.6,0-1,0.4-1,1V21c0,0.5,0.5,1,1,1s1-0.4,1-1v-6.1C19.4,14.3,19,13.9,18.4,13.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSelectIcon);
export default __webpack_public_path__ + "static/media/cardSelectIcon.8d5880aaca02e6685f353edfb30f67c9.svg";
export { ForwardRef as ReactComponent };